module.exports = __webpack_public_path__ + "static/media/concerns-board.b4c01bcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/concerns-board.svg
// module id = 314
// module chunks = 0